<svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 4"
    preserveAspectRatio="none"
    version="1.1"
>
    <defs>
        <linearGradient id="linearGradient" gradientUnits="userSpaceOnUse" >
            <stop offset="0%" stop-color="#00ff00" />
            <stop offset="50%" stop-color="#ffff00" />
            <stop offset="100%" stop-color="#ff0000" />
        </linearGradient>
    </defs>
    <g fill="none" [attr.stroke-width]="stroke" transform="translate(0,0)">
        <path [attr.d]="rectDimention" [attr.stroke]="getUrl('linearGradient')" />
    </g>
    <g fill="none" transform="translate(0,0)">
        <path
            id="linear"
            [attr.d]="rectDimention"
            [style.strokeDasharray]="circumference"
            [style.strokeDashoffset]="style()"
            [attr.stroke-width]="stroke + 1"
            class="value"
            [attr.stroke]="pathColor"
        />
    </g>
</svg>
